import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import useInitialize from "./useInitialize";
import useStore from "./useStore";
import { t } from "i18next";
import { UnenrollmentActionContext } from "./UnenrollmentActionContext";

function useUnenrollmentAction(index: any, formDefaultValues: any = {}): any {
  const initialize = useInitialize();
  const unenrollmentInitializeFunction = (id: any) => initialize({...formDefaultValues, ...{player_id: id}});

  /**
   * Form store success function definition
   */
  const onSuccessStore = () => {
    setShowModal(false);
    index(); // We pass the function to refresh the table on success
  };

  const store = useStore();
  const storeFunction = () => store(onSuccessStore);

  /** Creation and edition modal function and state definition */
  const { setShowModal } = useContext(UnenrollmentActionContext);

  /**
   * Creation and edition modal configuration definition
   */
  const modalConfig = {
    title: t("unenroll_player"),
    context: UnenrollmentActionContext,
    onSubmit: () => storeFunction(), //We pass the function for the submit of the modal
  };


  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t("are_you_sure_you_want_to_unenrollment_this_player?")}
    </CrudModuleFactoryModal>
  );

  /** END EDIT FORM ACTION */

  return {
    unenrollmentInitializeFunction,
    actionTemplate,
  };
}

export default useUnenrollmentAction;
